import { createSlice } from '@reduxjs/toolkit'

const contactUsSlice = createSlice({
    name: 'contactUs',
    initialState: {},
    reducers: {
        reportDWH: (state, action) => { }
    }
})

export const { reportDWH } = contactUsSlice.actions

export default contactUsSlice.reducer
